import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import videoImage from "@/assets/agent-user-detail/video@3x.webp";

export const VideoImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[videoImage]}
      {...props}
    />
  );
};

VideoImage.displayName = 'VideoImage';
